import { ApolloClient, InMemoryCache, HttpLink, split } from '@apollo/client';
import { setContext } from "@apollo/client/link/context"
import { OperationDefinitionNode } from "graphql";
import { WebSocketLink } from "@apollo/client/link/ws";
import { getMainDefinition, relayStylePagination } from "@apollo/client/utilities";
import ws from 'ws';

const webSocketImpl = typeof window === "undefined" ? ws : null


let https = process.env.GATSBY_URL_SERVER.includes('https://');
let wss = process.env.GATSBY_URL_SERVER.replace(https ? 'https' : 'http', https ? 'wss' : 'ws');

const httpLink = new HttpLink({
	uri: process.env.GATSBY_URL_SERVER,
});

const urlConnectionWs = () => {
	let https = process.env.GATSBY_URL_SERVER.includes('https://');
	return process.env.GATSBY_URL_SERVER.replace(https ? 'https' : 'http', https ? 'wss' : 'ws');
}

const wsLink = (token) => {
	return new WebSocketLink({
		uri: urlConnectionWs(),
		options: {
			reconnect: true,
			connectionParams: () => {
				return { headers: { 'Authorization': `Bearer ${token}` } };
			},

		},
		webSocketImpl
	});
};

const authLink = (token) => {
	return setContext((_, { headers }) => {
		const auth = `Bearer ${token}`
		return {
			headers: {
				...headers,
				Authorization: token ? auth : null,
			},
		}
	})
};

const splitLink = (token) => {
	return split(
		({ query }) => {
			const { kind, operation } = getMainDefinition(query) as OperationDefinitionNode
			return kind === 'OperationDefinition' && operation === 'subscription'
		},
		wsLink(token),
		authLink(token).concat(httpLink),
	);
};

export const createApolloClient = (token: string) => {
  return new ApolloClient({
    link: splitLink(token),
    cache: new InMemoryCache(),
  });
 };
